import { RootState } from "@store/index";

export const userSliceSelector = (state: RootState) => state.user;

export const loggedInUserPreferencesSelector = (state: RootState) => state.user.data!.preferences;

export const loggedInSelectedIAGroupIdSelector = (state: RootState) => state.user.data!.selectedAccountGroup;

export const userSegmentFunctionSelector = (state: RootState) => state.user.data?.segmentFunction;
